module.exports = __webpack_public_path__ + "img/how1.ed3b2e8f.png";